import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { PaymixService } from "../../services/paymix.service";
import { IPaymentMethod } from "../../models/PaymentMethod";
import useAppDispatch from "../../hooks/useAppDispatch";
import {
  getDefaultPaymentMethod,
  setPaymentMethods,
} from "../../store/userPaymentMethods/userPaymentMethodsSlice";

export const useGetPaymentMethodsQuery = (userId: string) => {
  const dispatch = useAppDispatch();
  return useQuery<IPaymentMethod[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_PAYMENT_METHODS, userId],
    queryFn: () =>
      PaymixService.getAllPaymentMethods(userId).then((res) => {
        dispatch(setPaymentMethods(res.data));
        dispatch(getDefaultPaymentMethod());
        return res.data;
      }),
    enabled: !!userId,
  });
};
